var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2006_1740)" } }, [
        _c("path", {
          attrs: {
            d: "M11.2385 0.855275L9.58831 2.50846L13.2976 6.21776L14.9478 4.56754C15.5967 3.91871 15.5967 2.86991 14.9478 2.22108L13.585 0.855275C12.9362 0.206445 11.8874 0.206445 11.2385 0.855275ZM8.85653 3.11581L8.58396 3.19877L4.31471 4.47866C3.72513 4.65642 3.25703 5.10675 3.06149 5.69336L0.436538 13.5208C0.323955 13.8556 0.406911 14.2289 0.652815 14.4807L5.20352 9.93298C5.11464 9.74633 5.06427 9.53894 5.06427 9.3197C5.06427 8.53459 5.70125 7.89761 6.48637 7.89761C7.27148 7.89761 7.90846 8.53459 7.90846 9.3197C7.90846 10.1048 7.27148 10.7418 6.48637 10.7418C6.26713 10.7418 6.05974 10.6914 5.87309 10.6026L1.32238 15.1533C1.57718 15.3992 1.94751 15.4851 2.2823 15.3695L10.1127 12.7446C10.6964 12.549 11.1497 12.0809 11.3274 11.4914L12.6073 7.22211L12.6903 6.94955L8.85653 3.11581Z",
            fill: "black",
            "fill-opacity": "0.88",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2006_1740" } }, [
          _c("rect", {
            attrs: {
              width: "15.169",
              height: "15.169",
              fill: "white",
              transform: "translate(0.323944 0.312988)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }